import React from 'react';
import { Mui, MuiIcons } from '@osu/react-ui';

/**
 * DashboardError Component
 * Displays error states with retry functionality
 */
function DashboardError({ error, onRetry }) {
  const getErrorMessage = () => {
    if (error?.message) {
      return error.message;
    }
    if (typeof error === 'string') {
      return error;
    }
    return 'An unexpected error occurred while loading your dashboard.';
  };

  const getErrorDetails = () => {
    if (error?.networkError) {
      return 'Please check your internet connection and try again.';
    }
    if (error?.graphQLErrors?.length > 0) {
      return 'There was an issue retrieving your application data.';
    }
    return 'Please try refreshing the page or contact support if the problem persists.';
  };

  return (
    <Mui.Container maxWidth="md" sx={{ py: 8, textAlign: 'center' }}>
      <MuiIcons.ErrorOutline sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
      
      <Mui.Typography variant="h4" component="h1" gutterBottom color="error">
        Unable to Load Dashboard
      </Mui.Typography>
      
      <Mui.Typography variant="body1" color="text.secondary" paragraph>
        {getErrorMessage()}
      </Mui.Typography>
      
      <Mui.Typography variant="body2" color="text.secondary" paragraph>
        {getErrorDetails()}
      </Mui.Typography>
      
      <Mui.Box sx={{ mt: 3, display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
        {onRetry && (
          <Mui.Button 
            variant="contained" 
            onClick={onRetry}
            startIcon={<MuiIcons.Refresh />}
            size="large"
          >
            Try Again
          </Mui.Button>
        )}
        
        <Mui.Button 
          variant="outlined" 
          onClick={() => window.location.reload()}
          startIcon={<MuiIcons.Home />}
          size="large"
        >
          Reload Page
        </Mui.Button>
        
        {/* <Mui.Button 
          variant="text" 
          href="mailto:honors-scholars@osu.edu"
          startIcon={<MuiIcons.Email />}
          size="large"
        >
          Contact Support
        </Mui.Button> */}
      </Mui.Box>


    </Mui.Container>
  );
}

export default DashboardError;